import { render, staticRenderFns } from "./VCardTitle.vue?vue&type=template&id=7ba4e3c2&functional=true"
import script from "./VCardTitle.vue?vue&type=script&lang=js"
export * from "./VCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports